import React from "react";
import { withRouter } from "react-router";
import classNames from "classnames";
import "./index.scss";
import { getTranslateTitle } from '../../../utils/objects-util.js';

const LinkControl = ({ column, value, history, onClick, isDisabled }) => {
    const handleOnClick = () => {
        if (!isDisabled){
            if (column.isLayout){
                onClick();
            } else {
                history.push(value);
            }
        }
    }

    return (
        <span className={classNames("linkControl", {"disabled": isDisabled})} onClick={handleOnClick}>
            {getTranslateTitle(column.title)}
        </span>
    )
}
   
    

export default withRouter(LinkControl);
